import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import Home from "./views/Home";
import PayMethods from "./views/PayMethods";
import Dashboard from "./views/Dashboard";
import Login from "./views/Login";
import Privacy from "./views/Privacy";
import Verifier from "./views/Verifier";
import PrivateRoute from "./routes/PrivateRoute";
import Winners from "./views/Winners";
import Tickets from "./views/Tickets";

import reportWebVitals from "./reportWebVitals";
import "./index.css";
import 'flag-icons/css/flag-icons.min.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider theme={{ token: { fontFamily: "Nunito-Regular" } }}>
      <GoogleReCaptchaProvider reCaptchaKey='6LfCRVksAAAAAK-BqWwbTJBKtXwd6r3zHMerzLk9'>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pagos" element={<PayMethods />} />
            <Route path="/verificador" element={<Verifier />} />
            <Route path="/privacidad" element={<Privacy />} />
            <Route path="/ganadores" element={<Winners />} />
            <Route path="/boletos" element={<Tickets />} />
            {/* <Route path="/verificador/:id" element={<Verifier />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />
            {/* <Route path="*" element={<NotFound />} /> */}
            <Route
              path="/v1/admin/dashboard"
              element={
                <PrivateRoute logged={true}>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/v1/admin/login"
              element={
                <PrivateRoute logged={false}>
                  <Login />
                </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </GoogleReCaptchaProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
